import { RolesIcon, UserIcon } from "allIcons";

export const siteTempleteUsersMenu = (view_users) =>
  [
    view_users && {
      module: "users",
      title: "users.menu.users",
      icon: <UserIcon />,
    },
    {
      module: "roles",
      title: "users.menu.roles",
      icon: <RolesIcon />,
    },
  ].filter((_) => _);
